<template>
  <div>
    <nav v-show="show" aria-label="Page navigation">
      <ul class="pagination  justify-content-center" >
        <li class="page-item">
          <div @click="clickNo('font')" class="page-link"  aria-label="Previous">
            <span aria-hidden="true">&laquo;</span>
            <span class="sr-only">上一页</span>
          </div>
        </li>
        <template v-if="first">
          <li class="page-item"><div class="page-link" @click="clickNo(1)" >1</div></li>
          <li  class="page-item disabled"><div  class="gap page-link" >...</div></li>
        </template>
        <li v-for="item in list"  @click="clickNo(item)" class="page-item"><div class="page-link" :class="{active:item===pageNo}" >{{item}}</div></li>
        <template v-if="last">
          <li class="page-item disabled"><div class="gap page-link" >...</div></li>
          <li class="page-item"  @click="clickNo(sum)"><div class="page-link" >{{sum}}</div></li>
        </template>
        <li @click="clickNo('next')"  class="page-item">
          <div class="page-link"  aria-label="Next">
            <span aria-hidden="true">&raquo;</span>
            <span class="sr-only">下一页</span>
          </div>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
  import Templete from "./templete";

  export default {
    components: {Templete},
    name: 'pagination',
    props: ['pageSize', 'pageNo', 'count'],
    data(){
      return{
        show:true,
        gap:false,
        first:false,
        last:false,
        sum:1,
        list:[]
      }
    },
    created(){
      this.sumPageFn()
    },
   watch:{
     pageNo(){
       this.sumPageFn()
     },
     count(){
       if(this.count){
         this.show=true
       }
       this.sumPageFn()
     }
   },
    methods:{
      sumPageFn(){
        let count =this.count*1,
          size = this.pageSize*1,
          no = this.pageNo*1,
          sum,start,end,list=[];
        this.sum=sum =Math.ceil(count/size);
        if(sum<=1){
          this.show=false
        }

        if(no<=4){
         start=1
          this.first=false
        }else{
          start=no-2
          this.first=true
        }
        if((no+3)>=sum){
          this.last = false;
          end = sum
        }else{
          this.last = true;
          end = no+2
        }
        for(start;start<=end;start++){
          list.push(start)
        }
        this.list=list
      },
      clickNo(no){
        let pageNo = this.pageNo;
        if(no==='font'){
          pageNo=pageNo-1;
          (pageNo)>0?no=pageNo:no=1;
        }else if(no==='next'){
          pageNo=pageNo+1;
          pageNo>this.sum?no=this.sum:no=pageNo;
        }
        this.$emit('click',no)
      }

    }

  }
</script>

<style type="scss" scoped>
  .page-link {
    margin: 0 1px;
    cursor:pointer;
    color: #1f2037;
  }
  .active{
    color:#03A9F5
  }

  .page-item:first-child .page-link {
    margin-left: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .page-item:last-child .page-link {
    border-top-right-radius: 0em;
    border-bottom-right-radius: 0rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/pagination.vue